angular.module("roles")

    .controller("RolesEditCtrl", ['$q', 'LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$timeout', '$filter', 'logService',
        function ($q, LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $timeout, $filter, logService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("ROLES_WRITE");

        $rootScope.title = $filter("translate")("roles.title");        
        $scope.editCode = true;
        $scope.search = { group_name: "" };
        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
            $rootScope.breadcrumb = [
                { title: $filter("translate")("roles.list"), url: "roles.list" },
                { title: $filter("translate")("roles.add") }
            ];
            $scope.role = {};

        } else {
            $rootScope.breadcrumb = [
                { title: $filter("translate")("roles.list"), url: "roles.list" },
                { title: $filter("translate")("roles.edit") }
            ];
        }




        Restangular.all('Permissions').getList().then(function (permissions) {
            $scope.permissions = permissions;
                Restangular.one('Roles', $stateParams.id).get().then(function (results) {
                    $scope.role = results;
                    angular.forEach($scope.permissions, function (permission) {
                        if (permission.group_name == null) permission.group_name = "Configuración";
                        angular.forEach($scope.role.FK_roles_permissions_roles, function (permission_role) {
                            if (permission.id == permission_role.permission_id) {
                                permission.checked = true;
                            }
                        });
                    });
                    $scope.editCode = LoginService.permissionExist("P_MODIFY_CODE_ROLE");
                    $scope.permissionsFromRoleBD = {};

                });

        });



        /*$scope.gridOptions = {
            pdfTitle: $filter("translate")("roles.title"),
            enablePaginationControls: false,
            showHeader: false,
            enableRowSelection: true,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false },
              { name: 'name', displayName: $filter("translate")("roles.name") },
              { name: 'description', displayName: $filter("translate")("roles.description") }
            ],
            getData: function (options) {

                var deferred = $q.defer();

                Restangular.all('Permissions').getList().then(function (permissions) {
                    $scope.gridOptions.data = permissions;
                    $timeout(function () {
                        if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                            Restangular.one('Roles', $stateParams.id).get().then(function (results) {
                                $scope.role = results;
                                logService.debug($scope.role);
                                $scope.editCode = LoginService.permissionExist("P_MODIFY_CODE_ROLE");

                                $scope.permissionsFromRoleBD = {};
                                $scope.gridOptions.data.forEach(function (permission) {
                                    for (var i = 0; i < $scope.role.FK_roles_permissions_roles.length; i++) {
                                        if (permission.id == $scope.role.FK_roles_permissions_roles[i].permission_id) {
                                            $scope.gridOptions.gridApi.selection.selectRow(permission);
                                        }
                                    }
                                });

                            });
                        }

                        var data = $scope.gridOptions.data;
                        data.totalRows = $scope.gridOptions.data.length;

                        deferred.resolve(data);

                    });


                }, function (response) {
                    logService.error("Error with status code", response.status);
                    alert("Error al cargar los datos")
                });

                return deferred.promise;

            }

        };*/
        


        $scope.saveRole = function (frmRole) {
            var roles_permissionsToBd = [];
            angular.forEach($scope.permissions, function (permission) {
                if (permission.checked) {
                    roles_permissionsToBd.push({
                        permission_id: permission.id,
                        role_id: $scope.role.id,
                        FK_roles_permissions_permissions: {
                            company_id: permission.company_id,
                            id: permission.id,
                            name: permission.name,
                            code: permission.code
                        },
                        roles: {
                            company_id: $scope.role.company_id,
                            id: $scope.role.id,
                            name: $scope.role.name,
                            code: $scope.role.code
                        }

                    });
                }
            });

          /*
            angular.forEach($scope.gridOptions.gridApi.selection.getSelectedRows(), function(permission){
                roles_permissionsToBd.push({
                    permission_id: permission.id,
                    role_id: $scope.role.id,
                    FK_roles_permissions_permissions: {
                        company_id: permission.company_id,
                        id: permission.id,
                        name: permission.name,
                        code: permission.code
                    },
                    roles: {
                        company_id: $scope.role.company_id,
                        id: $scope.role.id,
                        name: $scope.role.name,
                        code: $scope.role.code
                    }

                });
            });*/

            $scope.role.FK_roles_permissions_roles = roles_permissionsToBd;
            
            if (!angular.isUndefined($scope.role.id)) {                                
                $scope.role.put().then(function (result) {                    
                    if (!angular.isUndefined(result.id)){
                        $state.go("roles.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {                               
                Restangular.all('roles').post($scope.role).then(function (result) {
                    if (!angular.isUndefined(result.id)){
                        $state.go("roles.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter("translate")("roles.delete"),
                message: $filter("translate")("roles.delete_message")+" " + $scope.role.name + "?",
                onAccept: function () {
                    $scope.role.remove().then(function () {
                        $state.go("roles.list");
                    });
                }
            });
        };
        
    }]);